import React from 'react'
import { FullBlockLoader, CircleLoader } from '@deal/components'
import Logger from '#src/services/logger'
import { usePathContext } from '#src/components/Path/PathContext'
import { NotFound } from '#src/components/Errors'
import ContentfulQuery, { ContentfulImage } from '#src/containers/Contentful'
import { InterstitialPathFlowPageMetadataType } from '#src/generated/graphql'
import { LayoutProps } from '../'
import DefaultLayout from '../Default'
import Background from './components/Background'
import Footer from './components/Footer'

// Interstitials
import GenericInterstitial from '#src/components/Path/components/GenericInterstitial'
import GenericWithButtonInterstitial from './components/GenericWithButtonInterstitial'
import RequestPushNotificationInterstitial from '#src/components/Path/components/RequestPushNotificationsInterstitial'
import WhatHappensNextInterstitial from '#src/components/Path/components/WhatHappensNextInterstitial'

interface RoryPayloadContentfulResponse {
  loading: boolean
  content: {
    backgroundImage: ContentfulImage
    backgroundImagePosition: string
    headline: string
    subHeadline: string
    aboutCurated?: string
  }
}

const RoryLayout: React.SFC<LayoutProps> = props => {
  const pathContext = usePathContext()

  const pathCategory = pathContext.pathFlow.category ? pathContext.pathFlow.category : undefined
  const departmentId =
    pathContext.pathFlow.category && pathContext.pathFlow.category.department
      ? pathContext.pathFlow.category.department.id
      : undefined

  if (pathCategory && pathCategory.slug) {
    return (
      <ContentfulQuery template="roryPathLayout" variation={pathCategory.slug}>
        {({ content, loading }: RoryPayloadContentfulResponse) => {
          if (content) {
            return (
              <>
                <Background {...content}>
                  <DefaultLayout
                    hideLogo
                    interstitialMap={{
                      [InterstitialPathFlowPageMetadataType.GENERIC_WITH_TITLE]: GenericInterstitial,
                      [InterstitialPathFlowPageMetadataType.GENERIC_WITH_BUTTON]: GenericWithButtonInterstitial,
                      [InterstitialPathFlowPageMetadataType.REQUEST_PUSH_NOTIFICATION_PERMISSION]: RequestPushNotificationInterstitial,
                      [InterstitialPathFlowPageMetadataType.WHAT_HAPPENS_NEXT]: WhatHappensNextInterstitial
                    }}
                    {...props}
                  />
                </Background>
                <Footer aboutCurated={content.aboutCurated} departmentId={departmentId} />
              </>
            )
          } else if (loading) {
            return <FullBlockLoader loader={CircleLoader} />
          } else {
            Logger.captureException('No contentful entry for Rory template category', {
              pathCategorySlug: pathCategory.slug
            })

            return <NotFound />
          }
        }}
      </ContentfulQuery>
    )
  } else {
    Logger.captureException(`No path category for Rory template found`)

    return <NotFound />
  }
}

export default React.memo(RoryLayout)
